(function () {
    'use strict';

    angular
        .module('blocks.logger')
        .factory('logger', logger);

    logger.$inject = ['$log', 'toastr'];

    /* @ngInject */
    function logger($log, toastr) {
        var service = {
            showToasts: true,

            error: error,
            info: info,
            success: success,
            warning: warning,
            forceAcknowledge: forceAcknowledge,
            clearToast: clearToast,

            // straight to console; bypass toastr
            log: $log.log
        };

        return service;
        /////////////////////

        function error(message, data, title) {
            toastr.error(message, title);
            $log.error('Error: ' + message, data);
        }

        function info(message, data, title) {
            //toastr.info(message, title);
            $log.info('Info: ' + message, data);
        }

        function success(message, data, title) {
            toastr.success(message, title);
            $log.info('Success: ' + message, data);
        }

        function warning(message, data, title, show) {
            if (show) {
                toastr.warning(message, title);
            }
           
            $log.warn('Warning: ' + message, data);
        }

        var _forcedToast = null;
        function forceAcknowledge(message, data, title) {
            var cnfg = {
                "closeButton": true,
                "newestOnTop": false,
                "preventDuplicates": false,
                "onclick": null,
                "showDuration": "300",
                "hideDuration": "1000",
                "timeOut": "0",
                "extendedTimeOut": "0",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            }
            clearToast();
            _forcedToast = toastr.warning(message, title, cnfg);
        }

        function clearToast() {
            if (_forcedToast) {
                toastr.clear(_forcedToast);
            }
            _forcedToast = null;

        }

    }
}());
